// Imports the Link component from 'react-router-dom' for navigation between routes.
import { Link } from "react-router-dom";

// Imports a backup image from the local assets, to be used when a movie poster is not available.
import Backup from "../assets/images/backup.png"

// Defines a functional component named `Card` that takes a movie object as a prop.
export const Card = ({movie}) => {
  // Destructures the movie object to extract id, original title, movie overview, and poster path.
  const {id, original_title, overview, poster_path} = movie;

  // Determines the image source. If a poster path is provided, constructs the URL to the poster image. If not, uses the backup image.
  const image = poster_path ? `https://image.tmdb.org/t/p/w500/${poster_path}` : Backup ;

  // Returns the JSX for the card component.
  return (
    // The card's outer div with Tailwind CSS classes for styling: width, background, border, shadow, and margin.
    <div className="max-w-sm bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700 m-3">
        {/* Link component wrapping the movie poster image for navigation to the movie detail page using the movie's id. */}
        <Link to={`/movie/${id}`}>
            {/* The movie poster image with rounded top corners. The src attribute is dynamically set based on the movie's poster_path. */}
            <img className="rounded-t-lg" src={image} alt="" />
        </Link>
        {/* Container div for the text content of the card with padding. */}
        <div className="p-5">
            {/* Link component wrapping the movie title for navigation to the movie detail page using the movie's id. */}
            <Link to={`/movie/${id}`}>
                {/* The movie title displayed as a heading with Tailwind CSS classes for styling: margin, font size, font weight, and color. */}
                <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">{original_title}</h5>
            </Link>
            {/* Paragraph element for the movie overview with Tailwind CSS classes for styling: margin, font, and color. */}
            <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">{overview}</p>
        </div>
    </div>
  )
}
